import React, { useEffect, useState } from 'react';
import {withRouter} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import cn from "classnames";
import Loader from "../../../../components/utils/Loader";
import BackButton from "../../../../components/utils/BackButton";
import ReactTooltip from "react-tooltip";
import {TableHeader} from "./TableHeader";
import {groupBy, isEmpty} from "lodash";
import {ItemRow} from "./ItemRow";
import {utils, writeFileXLSX} from "xlsx";
import {formatDateTime} from "../../../../utils/formatDateTime";
import {styles} from "../../../../containers/goods/styles";
import { fetchInvoice, fetchRawsList, setActiveModalAction } from '../../../../action';
import { fetchFilials } from '../../../../action/handbook';
import { loaderRawsSelector, selectedRawsByType } from '../../../../selectors/raw';
import { suppliersLoadingSelector, suppliersSelector } from '../../../../selectors/forms';
import { parseNumToFixed } from '../../../../utils/common';
import moment from 'moment';

const textStyles = {
    display: "block",
    width: "auto",
    padding: "0.65rem 1rem",
    fontSize: "1rem",
    fontWeight: "400",
    lineHeight: "1.5",
    color: "#495057",
    backgroundColor: "#fff",
    backgroundClip: "padding-box",
    border: "1px solid #e2e5ec",
    borderRadius: "4px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    boxShadow: "none",
    outline: "none",
};

const DetailInvoiceForm = ({match}) => {
    const {id} = match.params;
    const dispatch = useDispatch();
    const form = useSelector(state => state.invoiceforms.detail);
    const loadingInvoice = useSelector(state => state.loaders.invoice);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const isMobile = window.innerWidth <= 768;
    const raws = useSelector(selectedRawsByType('raw'));
    const rawMaterialsLoading = useSelector(loaderRawsSelector);
    const suppliers = useSelector(suppliersSelector);    
    const suppliersLoading = useSelector(suppliersLoadingSelector);
    const loading = loadingInvoice || rawMaterialsLoading || suppliersLoading;

    const [groupedRawMaterials, setGroupedRawMaterials] = useState([]);

    useEffect(() => {
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(raws)) dispatch(fetchRawsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    useEffect(() => {
        const loadForm = async () => {
            if (id) {
                let invoice = null;
                if (form && form.id === parseInt(id, 10)) {
                    invoice = form;
                } else {
                    invoice = await dispatch(fetchInvoice(id));
                }
               if (invoice) {
                const rawsInvoice = (invoice.rawMaterials || []).map((raw) => {
                    const entity = raws.find((item) => item.id === raw.id);
                    if (!entity) return raw;
                    return {...raw, name: entity.name, productscategory: entity.productscategory, measure: entity.measure }
                });
                const groupedRawMaterials = groupBy(
                    rawsInvoice,
                    (item) =>
                        (item && item.productscategory && item.productscategory.title) ||
                        "Без категории"
                );
                setGroupedRawMaterials(groupedRawMaterials)
               }
            }
        };
        if (!isEmpty(raws)) loadForm();
    }, [dispatch, id, form, raws]);

    if (!form || !form.id || loading) return (
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const renderGroupedItems = (groupedItems) => {
        return Object.entries(groupedItems).map(([productscategory, items], index) => (
            <React.Fragment key={productscategory}>
                <tr
                    className="kt-datatable__row"
                    style={{fontWeight: 'bold', marginTop: isMobile && index === 0 ? '15rem' : undefined}}
                >
                    <td colSpan="3" className="kt-datatable__cell">{productscategory}</td>
                </tr>
                {items.map((item) => (
                    <ItemRow
                        key={item.id}
                        item={item}
                        style={textStyles}
                        isMobile={isMobile}
                    />
                ))}
            </React.Fragment>
        ));
    };

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const pointAdress = renderPointLabel(points.find((point) => point.id === form.point.id));

    const onExport = () => {
        const groupedItems = {
            'Сырье': groupedRawMaterials,
        };

        const exportData = [];

        exportData.push({
            'Филиал': pointAdress,
            'Дата': form.date ? new Date(form.date).toLocaleDateString() : 'Нет данных',
            'Поставщик': form.supplier ? form.supplier.name : '',
        });

        exportData.push({});

        Object.keys(groupedItems).forEach((type) => {
            exportData.push({ 'Название': type, 'Количество': '', 'Цена': '', 'Сумма': '' });

            Object.entries(groupedItems[type]).forEach(([productscategory, items]) => {
                exportData.push({ 'Название': productscategory, 'Количество': '', 'Цена': '', 'Сумма': '' });

                items.forEach((item) => {
                    const name = item.rawMaterial && item.rawMaterial.name ? item.rawMaterial.name : 'Нет данных';
                    const quantity = parseNumToFixed(item.quantity, 3) || 0;
                    const price = parseNumToFixed(item.price) || 0;
                    const totalPrice = parseNumToFixed(item.totalPrice) || 0;

                    exportData.push({
                        'Название': name,
                        'Количество': quantity,
                        'Цена': price,
                        'Сумма': totalPrice,
                    });
                });
            });
        });

        exportData.push({});
        exportData.push({
            'Название': '',
            'Количество': '',
            'Цена': 'Итоговая сумма:',
            'Сумма': form.totalSum || 0,
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Накладная");

        writeFileXLSX(wb, `Накладная № ${form.number}.xlsx`);
    };

    const getDateRealization = () => {
        if (!form.rawMaterials || form.rawMaterials.length === 0) return '*Не удалось получить дату';

        const dates = form.rawMaterials.map(raw => raw.dateRealization).filter(date => date && moment(date, 'DD.MM.YYYY HH:mm:ss').isValid());
        if (dates.length === 0) return '*Не удалось получить дату';

        const maxDate = moment.max(dates.map(date => moment(date, 'DD.MM.YYYY HH:mm:ss')));
        return maxDate ? moment(maxDate).format('DD.MM.YYYY HH:mm:ss') : '*Не удалось получить дату';
    }

    const openChangeLog = () => dispatch(setActiveModalAction({ field: 'changeLogAccountingModal', value: { id: form.id, changeLog: form.changeLog, created_at: form.created_at, type: 'invoice' }}));

    if (loading) return <div style={styles.formLoading}><Loader text="Загрузка бланка..." /></div>

    const supplier = suppliers.find((item) => item.id === form.supplier.id) || form.supplier;
    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{marginTop: 25}}>
            <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                    <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid"
                         style={{padding: 0}}>
                        <div className="kt-portlet kt-portlet--mobile">
                            <div className="kt-portlet__body kt-portlet__body--fit">
                                <div
                                    style={{position: 'relative', marginBottom: 0}}
                                    className={cn('kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded')}>
                                    {isMobile ? (
                                        <>
                                            <div className="kt-subheader__mobile-wrapper">
                                                <div className="kt-subheader not-mt kt-grid__item">
                                                    <div className="kt-container kt-container--fluid">
                                                        <div className="kt-subheader__main">
                                                            <h3 className="kt-subheader__title">Накладная номер: {form.number}</h3>
                                                            <div className="kt-subheader__mobile-header">
                                                                <div className="kt-subheader__mobile-actions">
                                                                    <BackButton/>
                                                                    <button className="btn btn-dark" onClick={onExport}> Экспорт </button>
                                                                    <button className="btn btn-secondary" onClick={openChangeLog}>История изменений</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="kt-subheader__main">
                                                            <div className="kt-subheader__mobile-actions">
                                                                <div style={textStyles}>
                                                                    <span>{form.date ? formatDateTime(form.date) : ''}</span>
                                                                </div>
                                                                <div style={{...textStyles}}>
                                                                <span>{pointAdress}</span>
                                                                </div>
                                                                <div style={{...textStyles}}>
                                                                    <span>{supplier.name || 'Поставщик не указан'}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="kt-subheader__main">
                                                            <div className="kt-subheader__mobile-actions" style={{ gap: 10 }}>
                                                                <div
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        wordWrap: 'break-word',
                                                                        overflowWrap: 'break-word',
                                                                        height: 'auto',
                                                                        whiteSpace: 'normal',
                                                                        padding: '0.65rem 1rem',
                                                                        fontSize: '1rem',
                                                                        fontWeight: '400',
                                                                        lineHeight: '1.5',
                                                                        color: '#495057',
                                                                        backgroundColor: '#fff',
                                                                        border: '1px solid #e2e5ec',
                                                                        borderRadius: '4px',
                                                                        boxShadow: 'none',
                                                                        outline: 'none',
                                                                    }}
                                                                >
                                                                    <span>{form.note ? form.note : 'Примечание не указано'}</span>
                                                                </div>
                                                                <div
                                                                style={{
                                                                    maxWidth: '100%',
                                                                    wordWrap: 'break-word',
                                                                    overflowWrap: 'break-word',
                                                                    height: 'auto',
                                                                    whiteSpace: 'normal',
                                                                    padding: '0.65rem 1rem',
                                                                    fontSize: '1rem',
                                                                    fontWeight: '400',
                                                                    lineHeight: '1.5',
                                                                    color: '#495057',
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #e2e5ec',
                                                                    borderRadius: '4px',
                                                                    boxShadow: 'none',
                                                                    outline: 'none',
                                                                }}
                                                            >
                                                                {form.fullRealization && <span>{`Дата реализации: ${getDateRealization()}`}</span>}
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container  kt-container--fluid">
                                                    <div className="kt-subheader__main">
                                                        <h3 className="kt-subheader__title">Накладная номер: {form.number}</h3>
                                                        <span
                                                            className="kt-subheader__separator kt-subheader__separator--v"></span>
                                                        <div className="kt-subheader__group" id="kt_subheader_search">
                                                            <BackButton/>
                                                            <button className="btn btn-dark" onClick={onExport}>Экспорт</button>
                                                            <button className="btn btn-secondary" onClick={openChangeLog}>История изменений</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container kt-container--fluid">
                                                    <div className="kt-subheader__main">
                                                        <div style={textStyles}>
                                                            <span>{form.date ? formatDateTime(form.date) : ''}</span>
                                                        </div>
                                                        <div style={{marginLeft: 10, ...textStyles}}>
                                                            <span>{pointAdress}</span>
                                                        </div>
                                                        <div style={{marginLeft: 10, ...textStyles}}>
                                                            <span>{form.supplier ? form.supplier.name : ''}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="kt-subheader not-mt kt-grid__item">
                                                <div className="kt-container kt-container--fluid">
                                                    <div className="kt-subheader__main" style={{ gap: 10 }}>
                                                        <div
                                                            style={{
                                                                maxWidth: '100%',
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                height: 'auto',
                                                                whiteSpace: 'normal',
                                                                padding: '0.65rem 1rem',
                                                                fontSize: '1rem',
                                                                fontWeight: '400',
                                                                lineHeight: '1.5',
                                                                color: '#495057',
                                                                backgroundColor: '#fff',
                                                                border: '1px solid #e2e5ec',
                                                                borderRadius: '4px',
                                                                boxShadow: 'none',
                                                                outline: 'none',
                                                            }}
                                                        >
                                                            <span>{form.note ? form.note : 'Примечание не указано'}</span>
                                                        </div>
                                                        <div
                                                            style={{
                                                                maxWidth: '100%',
                                                                wordWrap: 'break-word',
                                                                overflowWrap: 'break-word',
                                                                height: 'auto',
                                                                whiteSpace: 'normal',
                                                                padding: '0.65rem 1rem',
                                                                fontSize: '1rem',
                                                                fontWeight: '400',
                                                                lineHeight: '1.5',
                                                                color: '#495057',
                                                                backgroundColor: '#fff',
                                                                border: '1px solid #e2e5ec',
                                                                borderRadius: '4px',
                                                                boxShadow: 'none',
                                                                outline: 'none',
                                                            }}
                                                        >
                                                            {form.fullRealization && <span>{`Дата реализации: ${getDateRealization()}`}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    <table className="kt-datatable__table">
                                        {!isMobile && <TableHeader />}
                                        <tbody className="kt-datatable__body">
                                        {isEmpty(groupedRawMaterials)
                                            ? (
                                                <tr>
                                                    <td colSpan={3}>
                                                        <span className="kt-datatable--error">Нет данных о сырье</span>
                                                    </td>
                                                </tr>
                                            )
                                            : renderGroupedItems(groupedRawMaterials)
                                        }
                                        <tr>
                                            <td colSpan={5}>
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    padding: '10px 20px',
                                                    borderTop: '1px solid #e0e0e0',
                                                    alignItems: 'center'
                                                }}>
                                                    <div style={{fontWeight: 'bold', marginLeft: '10px'}}>
                                                        Общая сумма: {parseNumToFixed(form.totalSum)}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ReactTooltip effect="solid" type="dark" place="top"/>
                </div>
            </div>
        </div>
    );
}

export default withRouter(DetailInvoiceForm);
